/**
 * Copyright Mántum All Rights Reserved.
 */
import getTheme from './theme';
import { useCallback } from 'react';

import type { Theme } from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        entity?: string;
        refresh?: number;
        revalidate?: boolean;
    };
    icon?: string;
    loading?: boolean;
    theme?: Theme;
    title?: string;
    value?: number | string;
};

export default function Playful(props: PropTypes) {
    // prettier-ignore
    const {
        loading = false
    } = props

    const theme = getTheme(props.theme);
    const getLoading = useCallback(() => {
        return loading ? 'animate-pulse' : '';
    }, [loading]);

    return (
        <div
            className={`flex gap-4 max-h-[132px] cursor-pointer rounded font-bold px-4 py-8 items-center justify-center hover:from-pink-500 hover:to-yellow-500 ${theme} ${getLoading()}`}
        >
            {props.icon && (
                <img className='w-16 h-16' src={props.icon} alt='icon' />
            )}
            <div className='text-2xl font-medium text-white truncate'>
                <div className='truncate' title={props.title}>
                    {props.title}
                </div>
                <div className='min-h-[32px]'>{props.value}</div>
            </div>
        </div>
    );
}
